const axios = require("axios");
const VueModule = require("vue");
const Vue = VueModule.default || VueModule;

// ===== 登录页路由 =====
function goLogin() {
  window.location.replace("/#/");
}

function warn(msg) {
  if (Vue && Vue.prototype && Vue.prototype.$message) {
    Vue.prototype.$message({
      message: msg,
      type: "warning",
      duration: 2000,
    });
  } else {
    alert(msg);
  }
}

function success(msg) {
  if (Vue && Vue.prototype && Vue.prototype.$message) {
    Vue.prototype.$message({
      message: msg,
      type: "success",
      duration: 2000,
    });
  } else {
    alert(msg);
  }
}

function getContentType(header) {
  if (typeof header === "string" && header.trim()) return header.trim();
  return "application/x-www-form-urlencoded";
}

// ===== 统一 axios 实例 =====
const service = axios.create({
  timeout: 15000,
  withCredentials: true,
});

// ===== 是否需要登录 =====
function isNeedLogin(res) {
  const data = res && res.data ? res.data : {};

  if (data.msg === "请先登录") return true;
  if (data.code === 401 || data.code === 40101) return true;

  return false;
}

// ===== 业务成功码 =====
function isOk(res) {
  const data = res && res.data ? res.data : {};
  return data.code === 0 || data.code === 1021;
}

// ===== 解析失败回调 / content-type =====
// 支持：
// 1) fn(url, params, okCb, 'application/json')
// 2) fn(url, params, okCb, failCb, 'application/json')
// 3) fn(url, params, okCb, failCb)
function parseCbAndHeader(arg4, arg5) {
  let failCb = null;
  let header = "application/x-www-form-urlencoded";

  if (typeof arg4 === "string") {
    header = getContentType(arg4);
    return { failCb, header };
  }

  if (typeof arg4 === "function") {
    failCb = arg4;
    header = getContentType(arg5);
    return { failCb, header };
  }

  header = getContentType(arg5);
  return { failCb, header };
}

// ===== 处理成功响应 =====
function handleRes(res, okCb, failCb) {
  if (isOk(res)) {
    okCb && okCb(res);
    return true;
  }

  if (isNeedLogin(res)) {
    warn("请先登录");
    localStorage.removeItem("role");
    localStorage.removeItem("token");
    goLogin();
    return true;
  }

  const data = res && res.data ? res.data : {};
  const msg = data.msg || "请求失败";

  if (typeof failCb === "function") {
    failCb(res);
  } else {
    warn(msg);
  }

  return false;
}

// ===== 处理错误响应 =====
function handleErr(error, failCb) {
  console.error("请求异常：", error);

  let msg = "网络异常/接口错误";

  if (error) {
    // 超时
    if (error.code === "ECONNABORTED") {
      msg = "请求超时，请稍后重试";
    }
    // 有 response，说明服务端有返回
    else if (error.response) {
      const status = error.response.status;
      const data = error.response.data || {};

      if (status === 401) {
        msg = "请先登录";
        localStorage.removeItem("role");
        localStorage.removeItem("token");
        goLogin();
      } else if (status === 403) {
        msg = "无权限访问";
      } else if (status >= 500) {
        msg = "服务器异常，请稍后重试";
      } else {
        msg = data.msg || "请求失败";
      }
    }
    // 没有 response，常见是网络断开 / 跨域 / 预检失败 / 接口不可达
    else if (error.request) {
      msg = "网络异常/跨域受限/接口不可达";
    }
  }

  if (typeof failCb === "function") {
    failCb(error);
  } else {
    warn(msg);
  }
}

// ===== GET：Query 参数 =====
// 注意：GET 不主动设置 Content-Type，避免不必要的跨域预检
function getData(url, params, callback, arg4, arg5) {
  const { failCb } = parseCbAndHeader(arg4, arg5);

  service
    .get(url, {
      params: params || {},
    })
    .then((res) => handleRes(res, callback, failCb))
    .catch((error) => handleErr(error, failCb));
}

// ===== POST：body 参数 =====
// 默认表单；若传 application/json 就发 json
function postData(url, params, callback, arg4, arg5) {
  const { failCb, header } = parseCbAndHeader(arg4, arg5);
  const conType = getContentType(header);

  let body = params || {};
  const config = {
    headers: {
      "Content-Type": conType,
    },
  };

  if (conType.indexOf("application/x-www-form-urlencoded") !== -1) {
    if (!(body instanceof URLSearchParams)) {
      const form = new URLSearchParams();
      for (const k in body) {
        if (Object.prototype.hasOwnProperty.call(body, k)) {
          const v = body[k] === undefined || body[k] === null ? "" : body[k];
          form.append(k, v);
        }
      }
      body = form;
    }
  }

  service
    .post(url, body, config)
    .then((res) => handleRes(res, callback, failCb))
    .catch((error) => handleErr(error, failCb));
}
// function postData(url, params, callback, arg4, arg5) {
//   const { failCb, header } = parseCbAndHeader(arg4, arg5);
//   const conType = getContentType(header);

//   let body = params || {};
//   const config = {
//     headers: {
//       "Content-Type": conType,
//     },
//   };

//   // 表单提交
//   if (conType.indexOf("application/x-www-form-urlencoded") !== -1) {
//     const form = new URLSearchParams();
//     for (const k in body) {
//       if (Object.prototype.hasOwnProperty.call(body, k)) {
//         const v = body[k] === undefined || body[k] === null ? "" : body[k];
//         form.append(k, v);
//       }
//     }
//     body = form;
//   }

//   service
//     .post(url, body, config)
//     .then((res) => handleRes(res, callback, failCb))
//     .catch((error) => handleErr(error, failCb));
// }

// ===== 退出登录 =====
function backAcount() {
  const doLogout = () => {
    localStorage.removeItem("role");
    localStorage.removeItem("token");
    success("操作成功");
    goLogin();
  };

  if (Vue && Vue.prototype && Vue.prototype.$confirm) {
    Vue.prototype
      .$confirm("确定退出登录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
      .then(() => doLogout())
      .catch(() => {});
  } else {
    if (confirm("确定退出登录?")) doLogout();
  }
}

module.exports = {
  getData,
  postData,
  backAcount,
};


// WEBPACK FOOTER //
// ./src/common/util.js